import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

import { throwSlackMutationError } from './throw-slack-mutation-error';
import type { SlackIntegration, UpdateSlackIntegrationVariables } from './types';

type Response = { data: SlackIntegration };

export const useUpdateSlackIntegration = createMutation<
  Response,
  UpdateSlackIntegrationVariables,
  AxiosError
>({
  mutationFn: async (variables) => {
    const data: Record<string, unknown> = {};

    if (variables.channelId) {
      data.channel_id = variables.channelId;
    }

    if (variables.notificationPrefs) {
      const prefs = variables.notificationPrefs;

      data.notification_prefs = {
        ...(prefs.newReservation !== undefined && {
          new_reservation: prefs.newReservation,
        }),
        ...(prefs.cancellation !== undefined && {
          cancellation: prefs.cancellation,
        }),
        ...(prefs.reservationStatus !== undefined && {
          reservation_status: prefs.reservationStatus,
        }),
        ...(prefs.newSubscription !== undefined && {
          new_subscription: prefs.newSubscription,
        }),
      };
    }

    return client
      .patch('v2/internal/partners/organizations/integrations/slack', data)
      .then((response) => response.data)
      .catch((err: any) => {
        throwSlackMutationError(err, 'Something went wrong');
      });
  },
});
